// Réplica local del catálogo de eventos de pago. La FUENTE DE VERDAD es el
// `events.ts` de propi-web-nextjs (sección "Pagos / Pasarelas", todos con
// @emitter spa). Estos eventos se declaran allá por el Lexicon de Mixpanel, pero
// los EMITE esta SPA. Si cambiás un nombre acá, actualizá el catálogo de la Next
// en el mismo cambio (ver CLAUDE.md → "Eventos homologados con la SPA legacy").
//
// Plan: propi-web-nextjs/apuntes/plan/payment-tracking.md
export const PaymentEvents = {
  CheckoutViewed: 'Payment Checkout Viewed',
  CheckoutFailed: 'Payment Checkout Failed',
  MethodSelected: 'Payment Method Selected',
  Submitted: 'Payment Submitted',
  Completed: 'Payment Completed',
  Failed: 'Payment Failed',
  Cancelled: 'Payment Cancelled',
  ThreeDsChallenged: 'Payment 3DS Challenged',
} as const

export type PaymentEventName = (typeof PaymentEvents)[keyof typeof PaymentEvents]
